import utils from '../../../utils'

export function validate(record) {
  const errors = []

  if (!record.nome || String(record.nome).trim() === '') {
    errors.push({ field: 'nome', message: 'O campo nome é obrigatório!' })
  }

  if (!record.codigoPsp || String(record.codigoPsp).trim() === '') {
    errors.push({ field: 'codigoPsp', message: 'O campo PSP é obrigatório!' })
  }

  if (!record.ambiente || String(record.ambiente).trim() === '') {
    errors.push({ field: 'ambiente', message: 'O campo ambiente é obrigatório!' })
  }

  if (!record.clientId || String(record.clientId).trim() === '') {
    errors.push({ field: 'clientId', message: 'O campo Client ID é obrigatório!' })
  }

  if (!record.clientSecret || String(record.clientSecret).trim() === '') {
    errors.push({ field: 'clientSecret', message: 'O campo Client Secret é obrigatório!' })
  }

  const isBB = record.codigoPsp === 'BB'
  const isBradesco = record.codigoPsp === 'BRADESCO'
  if (isBB && (!record.appKey || String(record.appKey).trim() === '')) {
    errors.push({ field: 'appKey', message: 'O campo App Key é obrigatório para o Banco do Brasil!' })
  }

  if (isBB && (!record.recebedorConta || String(record.recebedorConta).trim() === '')) {
    errors.push({
      field: 'recebedorConta',
      message: 'O campo Conta do recebedor é obrigatório para o Banco do Brasil!',
    })
  }

  if (isBB && (!record.recebedorAgencia || String(record.recebedorAgencia).trim() === '')) {
    errors.push({
      field: 'recebedorAgencia',
      message: 'O campo Agência do recebedor é obrigatório para o Banco do Brasil!',
    })
  }

  if (isBB && (!record.recebedorTipoConta || String(record.recebedorTipoConta).trim() === '')) {
    errors.push({
      field: 'recebedorTipoConta',
      message: 'O campo Tipo de conta do recebedor é obrigatório para o Banco do Brasil!',
    })
  }

  if (isBradesco && (!record.recebedorNome || String(record.recebedorNome).trim() === '')) {
    errors.push({ field: 'recebedorNome', message: 'O campo Nome do recebedor é obrigatório para o Bradesco!' })
  }

  if (isBradesco && (!record.recebedorCnpj || String(record.recebedorCnpj).trim() === '')) {
    errors.push({ field: 'recebedorCnpj', message: 'O campo CNPJ do recebedor é obrigatório para o Bradesco!' })
  }

  if (!record.jornadaAtiva || String(record.jornadaAtiva).trim() === '') {
    errors.push({ field: 'jornadaAtiva', message: 'O campo Jornada Ativa é obrigatório!' })
  }

  if (record.diasExpiracaoSolicitacao != null && record.diasExpiracaoSolicitacao <= 0) {
    errors.push({ field: 'diasExpiracaoSolicitacao', message: 'Dias de expiração deve ser maior que zero!' })
  }

  if (record.webhookHabilitado && (!record.webhookUrl || String(record.webhookUrl).trim() === '')) {
    errors.push({ field: 'webhookUrl', message: 'URL do Webhook é obrigatória quando habilitado!' })
  }

  if (record.recebedorCnpj && String(record.recebedorCnpj).trim() !== '') {
    const cnpjLimpo = String(record.recebedorCnpj).replace(/\D/g, '')
    if (cnpjLimpo.length !== 14 && cnpjLimpo.length !== 0) {
      errors.push({ field: 'recebedorCnpj', message: 'CNPJ do recebedor deve ter 14 dígitos!' })
    }
  }

  utils.blankToNull(record)

  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
